

























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import MailingsMessages from "./MailingsMessages.vue";
import MailingsRecipients from "./MailingsRecipients.vue";
import MailingsLists from "./MailingsLists.vue";

import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";
import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Mailings",
  components: {
    MainTabbar,
    MailingsMessages,
    MailingsRecipients,
    MailingsLists,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
      currentMainTabbarTab: "",
      messageBodyAllowedTags: ["<p>", "</p>", "br", "<b>", "</b>", "<ul>", "</ul>", "<li>", "</li>", "<u>", "</u>"],
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Aussendungen",
          linkedComponent: "MailingsMessages",
          permissionRank: 2,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleMailings),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleMailings),
        },
        {
          title: "Empfänger:innen",
          linkedComponent: "MailingsRecipients",
          permissionRank: 2,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleMailings),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleMailings),
        },
        {
          title: "Listen",
          linkedComponent: "MailingsLists",
          permissionRank: 2,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleMailings),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleMailings),
        },
      ] as ModulesJson[];
    },
  },
});
